<template>
  <Notification
    :description="
      $t('rc_notifications_providers_available', {
        ConnectivityProvider: partners[0]?.originalName.value,
      })
    "
    v-bind="$attrs"
  >
    <template #ctaContent>
      <div class="tw:mt-3 tw:md:mt-0">
        <BaseLinkButton
          size="medium"
          class="tw:w-full tw:font-bold tw:text-blue-800 tw:text-nowrap"
          @click="openUpdateConnectivityProviderModal"
        >
          <span>{{ $t('notifications_cta_update') }}</span>
        </BaseLinkButton>
      </div>
    </template>
  </Notification>
</template>

<script setup>
import Notification from '@/components/productNotifications/Notification.vue'
import BaseLinkButton from '@/components/base/buttons/BaseLinkButton.vue'

import { usePartnerNames } from '@/components/homePage/queries/conversionFunnel'
import { useRateConnect } from '@/components/rateConnect/useRateConnect'
import { computed } from 'vue'

const props = defineProps({
  extraParameters: { type: Object, default: () => ({}) },
})

const partnerIds = computed(() => {
  if (props.extraParameters.alternativePartner)
    return [props.extraParameters.partnerId, props.extraParameters.alternativePartner?.partnerId]
  else return [props.extraParameters.partnerId]
})
const { partners } = usePartnerNames(partnerIds)

const { openUpdateConnectivityProviderModal } = useRateConnect()
</script>
